//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BoardAppContext from '../../../../BoardAppContext';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric, useGetBoardVariableDataSerieValues } from '../useOfBoard';
import { ActionButton } from '@fluentui/react';
import { Card} from 'react-bootstrap';
import BoardComponentContent from '../ComponentManager/BoardComponentContent';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { __Privileges, enum__BOARD_TEMPLATE_TYPE, enum__PRIVILEGES } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import Loading from '../../../../components/Templates/Site/Loading';
import SidePanelDataserieClose from '../../../../components/Products/sKPI/Board/BoardElementTypeBox/DataserieClose/SidePanelDataserieClose';
import { _checkSecurityUser } from '../../../../common/Helpers/HLP_Security';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';


function Business(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardPageRedy: boardPageRedy } = useSelector((state) => state.boardViewComponentsScope);

    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.BUSINESS ;
    const hasPageElementId = true;
    const inputParam_HideHeader = false;
    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    };

    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;
    
    const [structureFireGetData, setStructureFireGetData] = useState(true);
    const [boardStructureGeneric, setBoardStructureGeneric] = useState(null);
    const [boardVariableDataserieValues, setBoardVariableDataserieValues] = useState(null)
    const [isCloseDataseriesPanelOpen, setIsCloseDataseriesPanelOpen] = useState(false);
    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    
    useGetBoardStructureGeneric(BoardTypeId, queryStringElementId, boardStructureGeneric, setBoardStructureGeneric);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, queryStringElementId, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);
    useGetBoardVariableDataSerieValues(boardStructureGeneric, boardStructureGeneric !== null && boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : null, queryStringElementId, null, contextSite.kpiModule.boardCalendarFilterConfig, boardVariableDataserieValues, setBoardVariableDataserieValues)

    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardTypeId, !isNullUndefinedOrEmpty(boardStructureGeneric) ? (boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : 0) : 0, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)
    const boardContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        } 
    }

    const _priv_canCloseDataserie = _checkSecurityUser(contextSite.onlyObserver, userPropsKpi, contextSite.securityProps, queryStringElementId, enum__PRIVILEGES.KPI_CONTRACT_CLOSE);

    const generateContainerInfo = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={queryStringElementId}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardId={boardStructureGeneric[0].id}

                                            //[#NEW#]
                                            setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                    </div>
                        })
                    }
                </>
    };

    
    const onOpenCloseDataseries = () => {
        setIsCloseDataseriesPanelOpen(true);
    };

    const generateContainerDs = (boardStructure, container) => {
        return  <Card className='h-100 w-100'>
                    {
                        !inputParam_HideHeader &&
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                            <b>KPI</b>
                            <div className='book-toolbar'>
                                {
                                    _priv_canCloseDataserie &&
                                    <ActionButton iconProps={{ iconName: 'Lock' }} onClick={() => onOpenCloseDataseries()} allowDisabledFocus>
                                        { t('data-lang-btn-closedataseries') }
                                    </ActionButton>
                                }
                            </div>
                            </Card.Title>                            
                        </Card.Header>
                    }
                    <Card.Body className='px-1 py-0 h-100 w-100' style={{ overflowY: "auto", overflowX: "auto" }}>
                        {
                            container.l_components.map((component, index) => {
                                return  <div key={index} className='w-100'>
                                            <BoardComponentContent
                                                inputParam_ElementId={queryStringElementId}
                                                inputParam_ContainerComponent={component}
                                                inputParam_ContainerComponentIndex={index}
                                                inputParam_BoardId={boardStructureGeneric[0].id}
                                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        </div>         
                            })
                        }
                        {
                            boardVariableDataserieValues && isCloseDataseriesPanelOpen &&
                            <SidePanelDataserieClose
                                inputParam_BoardId={boardStructureGeneric[0].id}
                                inputParam_ElementId={queryStringElementId}
                                inputParam_DataSerieList={boardVariableDataserieValues}
                                inputParam_IsPanelOpen={isCloseDataseriesPanelOpen}
                                inputParam_SetterIsPanelOpen={setIsCloseDataseriesPanelOpen}
                            />
                        }
                    </Card.Body>
                </Card>
    };

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                <BoardAppContext.Provider value={ boardContextStructure }>
                {
                    boardPageRedy &&
                    <>
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                            <>
                                <CalendarFilter inputParam_BoardId={boardStructureGeneric[0].id} inputParam_ForceShowCalendar={true} />
                                {
                                    boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                        return <div key={indexBoardStructure}>
                                            {
                                                boardStructure.l_structure.length === 1 &&
                                                <ResponsiveGridLayout
                                                    measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                    breakpoints={layoutConfiguration.breakpoints}
                                                    cols={layoutConfiguration.cols}
                                                    rowHeight={layoutConfiguration.rowHeight}
                                                    isDraggable={false}
                                                    isDroppable={false}
                                                    isResizable={false}
                                                    //onLayoutChange={onLayoutChange}
                                                    //onResize={onResize}
                                                    //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                    margin={[10, 10, 10, 10]}
                                                >
                                                    {
                                                        boardStructure.l_structure[0].l_container.map((container, index) => (
                                                            <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainerInfo(boardStructure, container)}
                                                                { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                            </div>
                                                        ))
                                                    }
                                                </ResponsiveGridLayout>
                                            }
                                            {
                                                boardStructure.l_structure.length > 1 &&
                                                boardStructure.l_structure.map((structure, index) => {
                                                    return <ResponsiveGridLayout
                                                        key={index}
                                                        breakpoints={{ lg: 1200, xs: 480 }}
                                                        cols={ { lg: 12, xs: 6 } }
                                                        rowHeight={ structure.htmlStructure.rowHeight }
                                                        //onLayoutChange={onLayoutChange}
                                                        //onResize={onResize}
                                                        //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                        margin={[10, 10, 10, 10]}
                                                    >
                                                        {
                                                            structure.l_container.map((container, index) => (
                                                                <div key={index} className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                    {generateContainerInfo(container)}
                                                                    { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                                </div>
                                                            ))
                                                        }
                                                    </ResponsiveGridLayout>
                                                })
                                            }
                                        </div>
                                    }) 
                                }
                            </>
                        }
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                            <div className="pt-5 mt-4">
                                <MessageBox  
                                    inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </div>
                        } 
                    </>
                }
                {
                    !boardPageRedy &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                }
                </BoardAppContext.Provider>
            </>
    );
}

export default Business;